/**
 * Database Explorer — saved SQL snippets. Persisted in the `settings` KV
 * (scope='workspace', key='db_explorer.snippets', JSON array) — no new table
 * (PRD §5.3, §17). Query history is client-side (localStorage), not here.
 */

import { z } from "zod";
import type { Operation } from "../../types";

export const snippetSchema = z.object({
  name: z.string(),
  sql: z.string(),
});
export type SnippetDto = z.infer<typeof snippetSchema>;

export const snippetsList: Operation<
  void,
  void,
  void,
  z.infer<typeof snippetSchema>[]
> = {
  method: "GET",
  path: () => "/api/database/snippets",
  response: z.array(snippetSchema),
};

export const snippetsSaveBody = z.object({
  snippets: z.array(snippetSchema),
});

export const snippetsSave: Operation<
  void,
  void,
  z.infer<typeof snippetsSaveBody>,
  z.infer<typeof snippetSchema>[]
> = {
  method: "PUT",
  path: () => "/api/database/snippets",
  body: snippetsSaveBody,
  response: z.array(snippetSchema),
  // full replace of the snippets collection.
  invalidates: [snippetsList],
};

export const snippets = {
  list: snippetsList,
  save: snippetsSave,
};
